import { render } from "./layout-base-header.vue?vue&type=template&id=2d2d957c"
import script from "./layout-base-header.vue?vue&type=script&lang=js"
export * from "./layout-base-header.vue?vue&type=script&lang=js"

import "./layout-base-header.vue?vue&type=style&index=0&id=2d2d957c&lang=css"

import exportComponent from "/home/geangeowle/Workspace/NT-Marketing-Digital/ecolatas/ecolatas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__